import { render, staticRenderFns } from "./ClientSearchAreaStorage.vue?vue&type=template&id=9ecde87c&scoped=true&"
import script from "./ClientSearchAreaStorage.vue?vue&type=script&lang=js&"
export * from "./ClientSearchAreaStorage.vue?vue&type=script&lang=js&"
import style0 from "./ClientSearchAreaStorage.vue?vue&type=style&index=0&id=9ecde87c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecde87c",
  null
  
)

export default component.exports